var map = {
	"./1.jpg": "40c2",
	"./2.jpg": "e22e",
	"./3.jpg": "92b2",
	"./4.jpg": "2794",
	"./5.jpg": "ca47",
	"./6.jpg": "a8a9",
	"./7.jpg": "5922",
	"./ds820.jpg": "c33f",
	"./specif_eng.jpg": "7a94",
	"./specif_srb.jpg": "16b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b59";